import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { message } from "antd";
import sdk, { GraphQLError } from "@/sdk";

export const useErrorAccounts = () => {
  // Default: 2024-10 to now
  const now = new Date();
  const defaultEnd = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}`;

  const [beginDate, setBeginDate] = useState("20241001");
  const [endDate, setEndDate] = useState(defaultEnd);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["mcsdErrorAccounts", beginDate, endDate],
    queryFn: () => sdk.getMSCDErrorAccounts({ beginDate, endDate }),
    select: (data) => data.getMSCDErrorAccounts,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 min cache
    onError: (err: GraphQLError) => {
      message.error(err.response?.errors?.[0]?.message ?? "Алдаа гарлаа");
    },
  });

  return {
    data: data ?? [],
    loading: isLoading,
    beginDate,
    endDate,
    setBeginDate,
    setEndDate,
    refetch,
  };
};
